export enum ClientRole {
    Customer = "Customer",
    Operator = "Operator",
}
